import { useEffect, type ReactNode } from "react";
import { useBrowserSession } from "@softmax/web-features/session";
import { useResetSession } from "./use-reset-session";

export function VerifiedSession({
  sessionUserId,
  children,
  fallback,
}: {
  readonly sessionUserId: string;
  readonly children: ReactNode;
  readonly fallback?: ReactNode;
}) {
  const session = useBrowserSession();
  const resetSession = useResetSession();
  const verified =
    session.kind === "authenticated" || session.kind === "anonymous";
  const matches = session.session?.user.id === sessionUserId;
  useEffect(() => {
    if (verified && !matches) resetSession();
  }, [verified, matches, resetSession]);

  let content = fallback;

  if (matches)
    content = (
      <div
        style={{ display: "contents" }}
        inert={session.kind !== "authenticated"}
      >
        {children}
      </div>
    );
  else if (content === undefined && session.kind !== "unavailable")
    content = <output>Checking your account…</output>;

  return (
    <>
      {session.kind === "unavailable" && (
        <div role="alert">
          Your account could not be checked.{" "}
          <button onClick={() => void session.refresh()}>Try again</button>
        </div>
      )}
      {content}
    </>
  );
}
